module.exports = __webpack_public_path__ + "img/bsAttrCard_icon_05.99000c56.png";